import axios from "axios";
import Config from "../../config";
import "../../app/custom.scss";
import {
  errorCode,
  sessionExpired,
  callNotification,
  getUTCOffset,
} from "../constants";
import { handleApiError, handleAxiosError } from "../utils/errorHandler";

export const setMentionPageData = (value) => {
  return { type: "SET_MENTION_PAGE_DATA", payload: value };
};
export const setMentionPageInnerTabs = (value) => {
  return { type: "SET_MENTION_PAGE_INNER_TABS", payload: value };
};
export const setMentionTabsNews = (value) => {
  return { type: "SET_MENTION_TABS_NEWS", payload: value };
};
export const setDeepDiveInfoLoader = (value) => {
  return { type: "SET_INFO_LOADER", payload: value };
};

export const setDeepDiveTabLoader = (value) => {
  return { type: "SET_TAB_LOADER", payload: value };
};

export const setClearDeepDiveResponse = (value) => {
  return { type: "SET_CLEAR_DEEP_DIVE", payload: value };
};

export const setDetailedInsightObj = (value) => {
  return { type: "SET_DETAILED_INSIGHT_OBJ", payload: value };
};
export const setIsDetailedInsightVisible = (value) => {
  return { type: "SET_DETAILED_INSIGHT_MODAL", payload: value };
};

export const setTabClick = (value) => {
  return { type: "SET_TAB_CLICK", payload: value };
};

export const setFilter = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_FILTER", payload: value });
  };
};

export const setDatatype = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DATATYPE", payload: value });
  };
};
export const setDeepDiveFlag = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_FLAG", payload: value });
  };
};
export const setDeepDive = (value) => {
  let errorMessage;
  return async (dispatch) => {
    dispatch(setDeepDiveTabLoader(true));
    let body = { ...value, utcoffset: getUTCOffset() };
    let url = `${Config.config1.api_link}/graph/deep-dive`;
    axios
      .post(url, body)
      .then((response) => {
        dispatch({ type: "SET_DEEP_DIVE", payload: response });
        dispatch(setDeepDiveInfoLoader(false));
        dispatch(setDeepDiveTabLoader(false));

        if (response?.data?.status === "successful") {
          let firstTen = response?.data?.result?.mentions?.values?.sort(
            (a, b) => parseFloat(b.Engagement) - parseFloat(a.Engagement)
          );
          let obj = { data: firstTen?.slice(0, 10), page: 1, limit: 10 };
          dispatch(setMentionPageData(obj));
        }
        if (response?.data?.status === "error") {
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        dispatch(setDeepDiveTabLoader(false));
        handleAxiosError(error, dispatch);
      });
  };
};

//for sorting of Mention tab data based on engagement and followers

export const setSorting = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_MENTION_SORTING", payload: value });
  };
};

export const setDeepDiveWidgetLoaders = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEPDIVE_WIDGET_LOADERS", payload: value });
  };
};
